import { UPDATE_ANSWERS } from 'client/constants/actions';

type Votes = { [answerId: string]: number };

type RegularAnswerPayload = {
	cardId: string;
	answerId: string;
	votes?: Votes; // published version only
};

type AnswerInputPayload = {
	cardId: string;
	answerId: string;
	type: 'answerInput';
	data: { textContent: string; embedCode?: string; customGAEvent: Nullable<string> };
};

type PollMultipleAnswerPayload = {
	cardId: string;
	answerId: string;
	data: { textContent?: string; embedCode?: string; customGAEvent: Nullable<string> };
};

type SubmitCardAnswersPayload = {
	cardId: string;
	submitted: boolean;
	votes?: Votes; // published version only
};

type SortableTriviaAnswerPayload = {
	cardId: string;
	answerId: string;
	submitted: boolean;
	data: { isCorrect: boolean; textContent?: string; customGAEvent: Nullable<string> };
};

type SortablePollAnswerPayload = {
	cardId: string;
	answerId: string;
	answerIds: string[];
	data: { textContent: string; customGAEvent: Nullable<string> };
};

type SortablePollSubmitPayload = {
	cardId: string;
	submitted: boolean;
};

type UpdateVotesOnlyPayload = {
	cardId: string;
	votes: Votes;
};

type ResetCardAnswersPayload = {
	cardId: string;
	clear: true;
};

export type UpdateUserAnswersPayload =
	| ResetCardAnswersPayload
	| RegularAnswerPayload
	| AnswerInputPayload
	| PollMultipleAnswerPayload
	| SubmitCardAnswersPayload
	| SortableTriviaAnswerPayload
	| SortablePollAnswerPayload
	| SortablePollSubmitPayload
	| UpdateVotesOnlyPayload;

// Store selected answer ids and data
export function updateAnswers(payload: UpdateUserAnswersPayload) {
	return {
		type: UPDATE_ANSWERS,
		payload,
	};
}
